<h2 class="dialog-header">{{consts.TITLE_MAIN}}
    <mat-icon class="dialog-close-button" mat-dialog-close svgIcon="hub_close">
    </mat-icon>
</h2>
<div class="dialog-body">
    <div class="row" class="comfirmation-panel" *ngIf="isAnnouncementAdded">
        <mat-icon class="announcement-alert-icon" svgIcon="hub_announcements_success_tick">
        </mat-icon>
        <b>{{consts.SUCCESS}}</b><span>&nbsp;{{consts.SUCCESS_MESSAGE}}</span>
    </div>
    <div class="announcements-dialog-content">
        <ng-container *ngIf="!isLoading; else loading">
            <ng-container *ngIf="announcementListData.length!=0; else empty">
                <div class="row announcement-item" *ngFor="let item of announcementListData let indexOfItem=index">
                    <div class="row announcement-item-head">
                        <div class="col head-item">
                            <span class="title">Status</span>
                            <ng-container [ngSwitch]="getStatus(item.startDate,item.endDate)">
                                <div *ngSwitchCase="consts.STATUS_ACTIVE" class="content content-active">
                                    <mat-icon class="announcement-status-icon" svgIcon="hub_announcements_horn">
                                    </mat-icon>{{consts.STATUS_ACTIVE}}
                                </div>
                                <div *ngSwitchCase="consts.STATUS_SCHEDULED" class="content content-scheduled">
                                    <mat-icon class="announcement-status-icon" svgIcon="hub_announcements_clock">
                                    </mat-icon>{{consts.STATUS_SCHEDULED}}
                                </div>
                                <div *ngSwitchDefault class="content content-inactive">
                                    <mat-icon class="announcement-status-icon" svgIcon="hub_announcements_expired">
                                    </mat-icon>{{consts.STATUS_INACTIVE}}
                                </div>
                            </ng-container>
                        </div>
                        <div class="col head-item">
                            <span class="title">{{consts.FROM}}</span>
                            <span>
                                {{item.startDate | date: 'd MMM, h:mm a'}}
                            </span>
                        </div>
                        <div class="col head-item">
                            <span class="title">{{consts.TILL}}</span>
                            <span>
                                {{item.endDate | date: 'd MMM, h:mm a'}}
                            </span>
                        </div>
                        <div class="col head-item">
                            <span class="title">{{consts.RECIPIENTS}}</span>
                            <span>
                                {{getPermissionLevelName(item)}}
                            </span>
                        </div>
                        <div class="col head-action">
                            <mat-icon class="announcement-action-icon" svgIcon="hub_announcements_edit"
                                (click)="editAnnouncement(item, indexOfItem)">
                            </mat-icon>
                            <mat-icon class="announcement-action-icon" svgIcon="hub_announcements_delete"
                                (click)="deleteAnnouncement(indexOfItem)">
                            </mat-icon>
                        </div>
                    </div>
                    <div class="row announcement-item-body">
                        <span>
                            {{item.message}}
                        </span>
                    </div>
                </div>
            </ng-container>
            <ng-template #empty>
                <div class="row announcements-empty">
                    <div class="col-12">
                        <mat-icon svgIcon="hub_announcements_empty"></mat-icon>
                        <h2 class='no-announcements-message'>{{consts.LABEL_NO_ANNOUNCEMENTS}}</h2>
                    </div>
                </div>
            </ng-template>
        </ng-container>
        <ng-template #loading>
            <div class="loading-spinner">
                <mat-spinner [diameter]="50"></mat-spinner>
            </div>
        </ng-template>
    </div>
    <div class="row">
        <div class="col text-center">
            <button mat-raised-button class="announcements-dialog-save-btn"
                [disabled]="announcementListData.length>=consts.COUNT_OF_ANNOUNCEMENTS_LIST"
                (click)="createAnnouncement()">
                {{consts.BUTTON_CREATE_ANNOUNCEMENT}}
            </button>
        </div>
    </div>
</div>